import {
  subDays, subMonths, subWeeks, subYears,
} from 'date-fns';
import { DateRangeType } from 'src/components/search-listing/utils/types';

const getDateRangeDates = (dateRange: DateRangeType) => {
  switch (dateRange) {
    case DateRangeType.pastDay: {
      return {
        startDate: subDays(new Date(), 1).getTime(),
        endDate: new Date().getTime(),
      };
    }

    case DateRangeType.pastWeek: {
      return {
        startDate: subWeeks(new Date(), 1).getTime(),
        endDate: new Date().getTime(),
      };
    }

    case DateRangeType.pastMonth: {
      return {
        startDate: subMonths(new Date(), 1).getTime(),
        endDate: new Date().getTime(),
      };
    }
    case DateRangeType.threeMonths: {
      return {
        startDate: subMonths(new Date(), 3).getTime(),
        endDate: new Date().getTime(),
      };
    }
    case DateRangeType.pastYear: {
      return {
        startDate: subYears(new Date(), 1).getTime(),
        endDate: new Date().getTime(),
      };
    }
    default: {
      return { startDate: undefined, endDate: undefined };
    }
  }
};

export default getDateRangeDates;
